import { createFileRoute } from '@tanstack/react-router';
import { TrainingModule } from '@/modules/training';

export const Route = createFileRoute('/(dashboard)/_dashboard/approval/training')({
  component: TrainingModule,
});
